import { ReviewTeam } from './conditionTemplates';
import { ReviewTeamPill } from './ReviewTeamPill';

interface ReviewTeamPillsProps {
    teams: readonly ReviewTeam[];
    isCompact?: boolean;
}

export const ReviewTeamPills = ({ teams, isCompact = false }: ReviewTeamPillsProps) => (
    <>
        {teams.map((team) => (
            <ReviewTeamPill key={team} team={team} isCompact={isCompact} />
        ))}
    </>
);
